<template>
  <div>
    <b-card v-if="adding" :title="$t('company.add_fixed_ride_price')">
      <TransferFixedRidePriceForm
        :company-id="companyId"
        :airport-id="airportId"
        :vehicle-id="vehicleId"
        :any-division="anyDivision"
        @saved="onCreated"
        @cancelled="adding = false"
      ></TransferFixedRidePriceForm>
    </b-card>
    <b-card :title="$t('company.fixed_ride_prices')">
      <AdminTable
        ref="table"
        :api-builder="apiBuilder"
        :columns="columns"
        :row-actions="['edit', 'delete']"
        :on-edit-item="(item) => $set(item, '_showDetails', true)"
        :bulk-actions="[]"
        :search-data="{
          company_id: companyId,
          vehicle_id: vehicleId,
          airport_id: airportId,
        }"
      >
        <template #price="{ item }">
          <ValuePriceWithCurrency
            :item="{ priceInBaseCurrency: item.price }"
            attribute="price"
          />
        </template>
        <template #direction="{ item }">
          {{ $t('company.transfer_direction.' + item.direction) }}
        </template>
        <template #row-details="{ item }">
          <TransferFixedRidePriceForm
            :id="item.id"
            :any-division="anyDivision"
            @saved="onUpdated"
            @cancelled="$set(item, '_showDetails', false)"
          ></TransferFixedRidePriceForm>
        </template>
      </AdminTable>

      <b-button v-if="!adding" variant="success" @click="adding = true">
        <i class="icon-plus3"></i>
        {{ $t('general.add_new') }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import TransferFixedRidePricesApi from './TransferFixedRidePricesApi'

import AdminTable from '../stylemix-vue-admin/components/AdminTable.vue'
import TransferFixedRidePriceForm from './TransferFixedRidePriceForm.vue'
import ValuePriceWithCurrency from '../components/values/ValuePriceWithCurrency.vue'

export default {
  components: {
    AdminTable,
    TransferFixedRidePriceForm,
    ValuePriceWithCurrency,
  },

  props: {
    airportId: {
      type: Number,
      required: true,
    },
    companyId: {
      type: Number,
      default: null,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
    anyDivision: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      adding: false,
    }
  },

  computed: {
    columns() {
      return [
        {
          key: 'division_name',
          label: this.$t('company.fixed_ride_division_name'),
        },
        {
          key: 'zone_name',
          label: this.$t('company.fixed_ride_zone_name'),
        },
        {
          key: 'direction',
          label: this.$t('general.direction'),
        },
        {
          key: 'price',
          label: this.$t('company.fixed_ride_price'),
        },
      ]
    },
  },

  methods: {
    apiBuilder() {
      return new TransferFixedRidePricesApi().setParameter('any_division', this.anyDivision)
    },
    onCreated() {
      this.adding = false
      this.$refs.table.refresh()
    },
    onUpdated() {
      this.$refs.table.refresh()
    },
  },
}
</script>
